export const generateSearchFormItems = deviceTypeList => {
	return [
		{
			prop: 'caliber',
			keyWord: '口径',
			type: 'input',
			width: '240px',
		},
		{
			prop: 'deviceTypeId',
			keyWord: '设备类型',
			type: 'select',
			width: '280px',
			needAllForSearch: true,
			filterable: true,
			searchOption: deviceTypeList,
		},
	]
}
